import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Lookup } from '../../../../shared-components/lookup/lookup.model';
import { FreeReducedMealAppPerson } from '../../models/free-reduced-meal-app-person.model';

@Component({
  selector: 'app-frma-previous-person-selector',
  templateUrl: './frma-previous-person-selector.component.html',
  styleUrls: ['./frma-previous-person-selector.component.css']
})
export class FrmaPreviousPersonSelectorComponent implements OnInit {

  isChildren = false;
  isAdults = false;
  suffixes: Lookup[];
  previousPeople: FreeReducedMealAppPerson[];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<FrmaPreviousPersonSelectorComponent>
  ) {
    if (data) {
      this.suffixes = data.suffixes;
      this.previousPeople = data.previousPeople;
      this.isChildren = data.isChildren;
      this.isAdults = data.isAdults;
    }
   }

  ngOnInit(): void {
  }

  continueClick() {
    let selectedPeople: FreeReducedMealAppPerson[] = [];
    if (this.previousPeople) {
      selectedPeople = this.previousPeople.filter(o => o.isSelected);
    }
    this.dialogRef.close(selectedPeople);
  }

}
